import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Tooltip } from "@mui/material";
import { imageBaseURL } from "../../actions/Base_URL";
import { getEventRegistrationInfo } from "../../actions/action";

const RegistrationInfo = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { formData: initialFormData, userId, eventId } = location.state || {}; // Add safety check
  const [formData, setFormData] = useState(initialFormData);

  useEffect(() => {
    if (userId && eventId) {
      getEventRegistrationInfo(eventId, userId).then((res) => {
        if (res?.data?.registration) {
          const reg = res.data.registration;
          setFormData({
            ...reg.form_data,
            uploads: reg.file_uploads
          });
        }
      }).catch(err => console.error("Error fetching registration info:", err));
    }
  }, [userId, eventId]);

  return (
    <div className="relative">
      <div className="flex justify-between items-center px-4 mt-6">
        <p className="font-semibold text-lg text-white">Registration Details</p>
        <Tooltip title="Go Back" arrow>
          <button
            className="bg-lightBlue-500 mb-0 text-white active:bg-lightBlue-600 font-semibold text-sm px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
            type="button"
            onClick={() => navigate(-1)}
          >
            {"<"}
          </button>
        </Tooltip>
      </div>
      <div className="mt-6 px-6 relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded bg-blueGray-700">
        <div className="min-h-screen-75 w-full overflow-x-auto pt-6">
          {formData ? Object.entries(formData).map(([key, value]) => {
            // Filter out file object keys to prevent [object Object] display
            if (key !== "uploads" && (
              key === "image_upload" ||
              key === "ppt_upload" ||
              (formData.uploads && formData.uploads[key])
            )) {
              return null;
            }

            return (
              <div key={key} className="flex flex-col sm:flex-row sm:items-start py-2 min-h-4 w-full border-b border-blueGray-600">
                {key !== "uploads" ? (
                  <p className="w-full">
                    <span className="font-bold text-lightBlue-500 w-40 capitalize">{key.replace(/_/g, ' ')}:</span>
                    <span className="text-white ml-2"> {String(value)}</span>
                  </p>
                ) : (

                  <div className="w-full">
                    <span className="font-bold text-lightBlue-500 capitalize">{key}:</span>
                    <div className="mt-2 space-y-1">
                      {Object.entries(value).map(([fileKey, fileUrl]) => {
                        // Helper to beautify file names
                        const getDisplayName = (key) => {
                          if (key.includes('ppt_upload')) return 'PowerPoint Presentation';
                          if (key.includes('image_upload')) return 'Image Files';
                          return key.replace(/_/g, ' ').replace(/\d+/g, '').trim().replace(/\b\w/g, l => l.toUpperCase());
                        };

                        return (
                          <div key={fileKey} className="flex items-center space-x-2">
                            <span className="text-sm font-medium text-white capitalize">{getDisplayName(fileKey)}:</span>
                            <button
                              onClick={() => window.open(`${imageBaseURL}${fileUrl}`, "_blank")}
                              className="bg-lightBlue-500 mb-0 text-white active:bg-lightBlue-600 font-semibold text-sm px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"

                            >
                              View
                            </button>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>
            )
          }) : (
            <div className="w-full flex justify-center">
              <div className="bg-red-500 w-8/12 text-white text-center py-2 px-4 rounded-lg font-bold shadow-md">
                Did not register yet
              </div>
            </div>
          )}


        </div>
      </div>
    </div>

  );
};

export default RegistrationInfo;
